import { Dispatch, SetStateAction } from 'react';

import { CancelStage as CorpsCancelStage, RefundStage as CorpsRefundStage, RefundStatus as CorpsRefundStatus } from '@/__generated__/CorpsSection.graphql';
import {
  CancelStage as IndisCancelStage,
  RefundStage as IndisRefundStage,
  RefundStatus as IndisRefundStatus,
  RefundSubStage
} from '@/__generated__/IndisSection.graphql';
import { INVITE_EVENT_PERIOD } from '@/lib/constants/event';
import { INVITE_PROMOTION_PATH, 비즈넵케어환급홈링크 } from '@/lib/constants/link';

export type ButtonType = 'primary' | 'basic' | 'secondary' | 'warning';
export type CurrentItemProps = {
  item: {
    applicationDt: string | null | undefined;
    businessInfo:
      | {
          taxpayerName?: string | null | undefined;
          hometaxBizName?: string | null | undefined;
          hometaxBizNo?: string | null | undefined;
        }
      | null
      | undefined;
    partnerInfo?:
      | {
          defaultFeeRate: string;
          feeRate: string;
          partnerName: string;
        }
      | null
      | undefined;
    cancelStage: IndisCancelStage | CorpsCancelStage | null | undefined;
    office: string | null | undefined;
    paymentAmount: number | null | undefined;
    paymentClosingDt: string | null | undefined;
    paymentExpectDt?: string | null | undefined;
    refundAmount: string;
    refundHistoryId?: string;
    refundId: string;
    refundReportDt: string | null | undefined;
    refundResultDt: string | null | undefined;
    refundResultExpectDt: string | null | undefined;
    refundStage: IndisRefundStage | CorpsRefundStage | null | undefined;
    refundStatus: IndisRefundStatus | CorpsRefundStatus;
    refundSubStage: RefundSubStage | null | undefined;
    lostReason: string | null | undefined;
    userFee: number | null | undefined;
    tin: string;
    reSearchRequestId?: number | null;
    virtualAccountInfo:
      | {
          account: string;
          bank: string;
          owner: string;
          paymentAmount: string;
        }
      | null
      | undefined;
    tritxRefundInfo?:
      | {
          applicationDt: string | null | undefined;
          businessInfo:
            | {
                taxpayerName: string | null | undefined;
              }
            | null
            | undefined;
          refundAmount: string;
          refundStatus: IndisRefundStatus;
          cancelStage: IndisCancelStage | null | undefined;
          tritxReSearchRequestId?: number | null;
        }
      | null
      | undefined;
  };
  handleButtonClick?: () => void;
  sectionType: 'indis' | 'indis-tritx' | 'corps';
  setHasHoverAnimationBasicButton?: Dispatch<SetStateAction<boolean>>;
};

export type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export type VirtualAccountInfo = {
  owner: string;
  bank: string;
  account: string;
  paymentAmount: string;
};

export type AdvertisingCardProps = {
  overText: string;
  title: string;
  imagePath: string;
  action: {
    type: 'popup' | 'redirect' | 'share';
    link: string;
    shareTitle?: string;
    userEvent?: string;
  };
};

export type AdvertisingCardListProps = (AdvertisingCardProps & {
  start: Date;
  end: Date;
  excludedWorkingPlatforms?: string[];
})[];

export const TAX_REFUND_SUMMARY_PAGE_CATEGORY = 'home';

export const EVENT_ADVERTISING_CARD_LIST: AdvertisingCardListProps = [
  {
    title: '친구 초대할 때마다 포인트 지급',
    overText: '첫 초대는 네이버페이 10,000P 드려요!',
    imagePath: '/lotties/lottie-07promo-invite.json',
    start: new Date(INVITE_EVENT_PERIOD.start),
    end: new Date(INVITE_EVENT_PERIOD.end),
    action: {
      type: 'redirect',
      link: INVITE_PROMOTION_PATH,
      userEvent: 'home_refund.ads_invite'
    }
  },
  {
    title: '사업경비10% 생활경비5% 적립',
    overText: '사장님카드로 사업과 생활 혜택 동시에!',
    imagePath: '/images/symbols/kbcard.png',
    start: new Date('2024-12-11T00:00:00+09:00'),
    end: new Date('2025-06-30T24:00:00+09:00'),
    excludedWorkingPlatforms: ['kbank'],
    action: {
      type: 'popup',
      link: 'https://card.kbcard.com/CRD/DVIEW/HCAMCXPRICAC0076?mainCC=a&cooperationcode=09291&solicitorcode=7030157001',
      userEvent: 'home_refund.ads_ceocard'
    }
  }
];

export const MORE_ADVERTISING_CARD_LIST: AdvertisingCardListProps = [
  {
    title: '비즈넵 케어로 기장료 줄이기',
    overText: '비즈넵이 만든 월 3만원 세무기장',
    imagePath: '/images/illus-icons/icg_shield-heart_md.svg',
    start: new Date('2024-10-01T00:00:00+09:00'),
    end: new Date('2026-07-31T00:00:00+09:00'),
    excludedWorkingPlatforms: ['kbank'],
    action: {
      type: 'popup',
      link: 비즈넵케어환급홈링크,
      userEvent: 'home_refund.ads_care'
    }
  }
];
